
import React from 'react';
import { User } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { useLanguage } from '@/context/language-context';
import { EscortProfile } from '@/types';

interface ProfileAboutMeProps {
  profile: EscortProfile;
}

const ProfileAboutMe: React.FC<ProfileAboutMeProps> = ({ profile }) => {
  const { t } = useLanguage();

  return (
    <Card>
      <CardContent className="p-0">
        <div className="bg-pink-50 py-3 px-6 border-b border-pink-100">
          <h3 className="text-lg font-medium text-pink-700 flex items-center">
            <User className="w-5 h-5 mr-2 text-pink-500" /> 
            {t('profile.about_me')}
          </h3>
        </div>
        
        <div className="p-6">
          <p className="text-gray-700 leading-relaxed whitespace-pre-line">
            {profile.bio?.full || `Ciao! I am Mia, a stylish Italian model with a vibrant personality and insatiable curiosity. Born and raised in Milan, I embody the Italian passion for life, food, and romance. I adore adventure, whether it's exploring new destinations or engaging in intellectual dialogue. My playful nature and genuine interest in people make every encounter both exciting and comfortable. I pride myself on creating authentic connections, filled with laughter, meaningful conversation, and genuine affection. When not traveling or modeling, I enjoy cooking traditional Italian dishes and practicing yoga to maintain my limber physique.`}
          </p>
          {/* Favorite phrases */}
          <div className="mt-6 bg-pink-50 rounded-lg p-4 border border-pink-100">
            <p className="text-center text-pink-700 italic">
              "J'aime parler français, danser, cuisiner, voyager, écouter et réfléchir"
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default ProfileAboutMe;
